import styled from '@emotion/styled';
import React from 'react';
import { Box, Flex } from '../Rebass';
import Text from '../Text';
import { cardHeadlineStyle, cardWrapperStyle } from './common';
import { CardProps } from './types';

const CardWrapper = styled(Flex)(cardWrapperStyle);
const StyledHeading = styled(Text)(cardHeadlineStyle);

const CardSmall = ({
  headline,
  description,
  image,
  renderCta,
  bg,
  padding,
  colorScheme,
  isLink,
  imageSx,
}: CardProps) => (
  <CardWrapper flexDirection="column" alignItems="start" bg={bg} {...padding}>
    {image ? (
      <Box mb={[1]} width="100%" sx={imageSx}>
        <>{image}</>
      </Box>
    ) : null}
    {headline && (
      <Box mb={[1]} sx={{ textAlign: 'left' }} width="100%">
        <StyledHeading
          className="card-headline"
          isLink={isLink}
          size="small"
          fontWeight="bold"
        >
          {headline}
        </StyledHeading>
      </Box>
    )}
    {description ? (
      <Box mb={[1]} width="100%" textAlign="left">
        <Text size="small">{description}</Text>
      </Box>
    ) : null}
    {renderCta && <Box>{renderCta(colorScheme)}</Box>}
  </CardWrapper>
);

CardSmall.defaultProps = {
  headline: '',
  description: '',
  image: null,
  renderCta: null,
  bg: 'transparent',
  padding: {},
  colorScheme: 'default',
};

export default CardSmall;
